export default {
  "title": {
    "operations": "Indicadores de todas as operações",
    "carrier": "Indicadores de todas as operadoras",
    "plant": "Indicadores todas as plantas",
    "driversAtRisk": "Motoristas em risco (Evolução diária)",
    "distribution": "distribuição",
    "microSleep": "Eventos de sonolência / 100 HR Dirigindo diariamente",
    "microSleepBar": "Eventos de sonolência diários",
    "behavior": "Nota comportamental diária",
    "ubicationpvt": "Indicadores de todos os locais PVT",
    "contract": "Indicadores de todos os contratos",
    "evolutionMicrosleeps": "Evolução dos eventos de sonolência",
    "general": {
      "operations": "todas as operações",
      "carrier": "todas as operadoras",
      "plant": "todas as plantas",
      "ubicationpvt": "todos os locais PVT",
      "contract": "todos os contratos"
    }
  },
  "tableTitle": {
    "operations": "Operações",
    "operation": "Operação",
    "carrier": "Operadora",
    "carriers": "Transportadoras",
    "drivers": "Motoristas",
    "atRisk": "Em risco",
    "distribution": "Distribuição em risco",
    "driversAtRisk": "Motoristas em risco (Evolução diária)",
    "inspectionCarriedOut": "Inspeções %",
    "formAvgRange": "Pontuação média",
    "evolutionScore": "Nota de evolução",
    "inspections": "Inspeções",
    "fails": "Falhas",
    "severityFailsColor": "Falhas de gravidade",
    "microSleep": "Eventos de sonolência / 100 HR Dirigindo diariamente",
    "microSleepBar": "Eventos de sonolência diários",
    "behavior": "Nota comportamental diária",
    "ubicationpvt": "Localização PVT",
    "ubicationpvts": "Localização PVT",
    "contract": "Contrato",
    "contracts": "Contrato",
    "numberRanking": "Nº de classificação",
    "driverName": "Nome do motorista",
    "biocompatibilityIndex": "Índice de Biocompatibilidade"
  },
  "filter": {
    "all": "Todos",
    "formTypes": "Tipo",
    "existentUsers": "Inspetor",
    "existentPersons": "Condutor",
    "existentVehicles": "Veículo",
    "existentForms": "Forma",
    "existentFails": "Falhas",
    "selectType": "Tipo",
    "selectInspector": "Inspetor",
    "selectDriver": "Condutor",
    "selectVehicle": "Veículo",
    "selectForm": "Forma",
    "selectFails": "Falhas",
    "selectTask": "Tarefas",
    "selectState": "Estado"
  },
  "text": {
    "withFails": "Perfeito"
  },
  "graphTooltip": {
    "outOfRisk": "Fora de risco",
    "midleRisk": "Risco médio",
    "atRisk": "Em risco",
    "LOWRISK": "Fora de risco",
    "OUTOFRISK": "Fora de risco",
    "MIDDLERISK": "Risco médio",
    "HIGHRISK": "Em risco",
    "OPEN": "Abertas",
    "OVERDUE": "Vencidas",
    "CLOSEDOVERDUE": "Fechadas vencidas",
    "CLOSED": "Fechadas a tempo",
    "ACCEPTED": "Aprovados",
    "FAIR": "Aprovados com observações",
    "REJECTED": "Reprovados",
    "NODATA": "Sem informação",
    "WITHOUTINFORMATION": "Sem informação",
    "SYNC": "Sincronizados",
    "SYNCWITHDELAY": "Sincronizado com atraso",
    "NOTSYNC": "Fora de sincronia",
    "DONE": "A tempo",
    "DONEWITHDELAY": "Atrasado",
    "PENDING": "Não realizada",
    "GOOD": "Baixa",
    "MEDIUM": "Média",
    "BAD": "Alta"
  },
  "fatigue": {
    "labelText": "Representa a porcentagem de motoristas com Índice de Biocompatibilidade (IBC) acima de 60 na data até. O IBC nos permite identificar quão arriscada é a estrutura de turnos de um motorista. É calculado levando em consideração variáveis como: jornada de trabalho, duração das pausas, total de horas trabalhadas, entre outras. Para isso, são processados os horários de início e término de trabalho dos últimos 14 dias e é entregue esse índice, que varia entre 0 e 100.",
    "underRisk": "Baixo risco",
    "midleRisk": "Risco médio",
    "to": "a",
    "highRisk": "Alto risco",
    "driversAtRisk": "Alto risco",
    "distributionIndex": "Distribuição do Índice de Biocompatibilidade dos condutores na data selecionada no filtro \"até\". Distribuído em baixo risco, médio risco e alto risco.",
    "biocompatibilityEvolution": "Evolução da biocompatibilidade",
    "driversAtRiskText": "Representa o percentual de motoristas de alto risco devido à estrutura de seu turno de trabalho.",
    "ratesHistogramText": "Permite visualizar com maior nível de detalhe quantos drivers estão em cada nível de risco.",
    "mainIndicatorsText": "Permitem uma rápida visão geral do funcionamento da operação e seus potenciais fatores de risco."
  },
  "nfa": {
    "distributionRisk": "Distribuição em risco",
    "underRisk": "Baixo Risco Total",
    "driverFatigue": "Representa a % de motoristas/dia com nível de fadiga acumulado em 4 períodos de tempo selecionados",
    "fatigueLevelAccumulation": "Nível de fadiga acumulado: indicador que calcula a probabilidade de ocorrência de pelo menos um evento de sonolência em uma jornada de trabalho nas próximas 24 horas. Existem 4 níveis classificados de acordo com o risco",
    "percentageEmsOne": "0% a 2% de sofrer um evento de sonolência no dia seguinte",
    "percentageEmsTwo": "2% a 10% de sofrer um evento de sonolência no dia seguinte",
    "percentageEmsThree": "10% a 20% de sofrer um evento de sonolência no dia seguinte",
    "_percentageEmsThree": "20% a 100% de sofrer um evento de sonolência no dia seguinte",
    "howItGoes": "Como você está se saindo em relação ao objetivo",
    "meta": "Meta",
    "before": "Período anterior",
    "to": "a",
    "driverNumber": "Nº de motoristas",
    "atRisk": "Em risco",
    "riskPeriod": "% Período de risco",
    "driversAtRisk": "% Motoristas em risco",
    "riskDistribution": "Distribuição em risco",
    "deviationDitribution": "Desvios de distribuição",
    "noData": "Não há mais dados",
    "title": "Evolução do nível de fadiga acumulado em todas as operações",
    "titleSecond": "Indicadores todas as operações",
    "indicadors": "Indicadores de todas as operadoras",
    "now": "Período atual",
    "overdue": "Vencido",
    "closedoverdue": "Fechado expirado",
    "open": "Aberto",
    "closed": "Fechado"
  },
  "ffdSleep": {
    "MONTH": "Mês",
    "DAY": "Dia",
    "WEEK": "Semana",
    "downloadExcel": "Baixar dados em arquivo Excel",
    "downloadSummaryExcel": "Baixar dados de resumo",
    "downloadNoProcessExcel": "Baixar dados brutos",
    "noDataAvailable": "Nenhuma informação disponível",
    "apiError": "Erro ao carregar dados",
    "noDevs": "Sem desvios",
    "lastPeriod": "Período anterior",
    "thisPeriod": "Período atual",
    "to": "a",
    "betterPeriod": "melhor em relação ao período anterior",
    "worstPeriod": "pior em relação ao período anterior",
    "equalPeriod": "Sem alterações em relação ao período anterior",
    "graphTooltip": {
      "ACCEPTED": "Aprovados",
      "FAIR": "Aprovados com observações",
      "REJECTED": "Reprovados",
      "NODATA": "Sem informação",
      "WITHOUTINFORMATION": "Sem informação",
      "SYNC": "Sincronizados",
      "SYNCWITHDELAY": "Sincronizado com atraso",
      "NOTSYNC": "Fora de sincronia"
    },
    "FFDResult": {
      "indicatorPeriod": "Taxa de rejeição de FFD do período",
      "resultsDistribution": "Distribuição dos resultados do FFD para o período",
      "title": "Evolução da taxa de rejeição de fitness for duty (FFD)",
      "evTooltip": "Rejeitado",
      "indicatorHelp1": "Representa a porcentagem total de ocasiões em que um número de pessoas foi avaliado como NÃO ADEQUADO para o trabalho, isso é conhecido como rejeição por FITNESS FOR DUTY.",
      "indicatorHelp2": "Este indicador é calculado com base no número total de avaliações esperadas no período de datas selecionado.",
      "indicatorHelp3": "Atualmente, a taxa total de rejeição é",
      "evHelp1": "Representa a evolução da taxa de rejeição para FITNESS FOR DUTY durante o período de data selecionado.",
      "evHelp2": "O número representa a porcentagem de rejeições para a data dd-mm-yyyy.",
      "distHelp1": "Representa o número de pessoas para cada conjunto de resultados FITNESS FOR DUTY para o intervalo de datas selecionado.",
      "cat1Label": "Aprovado",
      "cat1": "pessoas aptas para o trabalho.",
      "cat2Label": "Aprovado com comentários",
      "cat2": "pessoas aptas para trabalhar sob monitoramento e/ou plano de mitigação de medidas preventivas de fadiga.",
      "cat3Label": "Rejeitado",
      "cat3": "pessoas que não estão aptas para trabalhar.",
      "cat4Label": "Sem informação",
      "cat4": "pessoas que não sincronizaram suas bandas de sono corretamente.",
      "desvHelp1": "Representa o número de variações geradas no período selecionado e seu status atual:",
      "desvCat1Label": "Fechado na hora",
      "desvCat2Label": "Abiertas",
      "desvCat3Label": "Atrasado",
      "desvCat4Label": "Fechado expirado",
      "labelRate": "Taxa de rejeição",
      "between": "Entre",
      "categoryHelp": "Categoria de agrupamento de resumo.",
      "driverNumber": "Pessoas",
      "driverNumberHelp": "Número de pessoas visualizadas no período de datas selecionado.",
      "atRisk": "Rejeições FFD",
      "atRiskHelp": "Representa o número de rejeições por FITNESS FOR DUTY para a data dd-mm-yyyy.",
      "riskPeriod": "% rejeições de período",
      "driversAtRisk": "Evolução da taxa de rejeição de FFD",
      "riskDistribution": "Distribuição dos resultados do FFD",
      "deviationDitribution": "Distribuição de desvios por rejeição de FFD",
      "noData": "Sem mais dados",
      "now": "Este período",
      "overdue": "Vencido",
      "closedoverdue": "Fechado expirado",
      "open": "Aberto",
      "closed": "Fechado",
      "generalHelp": "* Rejeição: Refere-se à(s) ocasião(ões) em que uma ou mais pessoas foram avaliadas como NÃO ADEQUADAS para trabalhar no cálculo de FITNESS FOR DUTY."
    },
    "FFDSync": {
      "indicatorPeriod": "Taxa de incidentes de sincronização da pulseira do sono durante o período",
      "resultsDistribution": "Distribuição do status de sincronização das pulseiras de sono durante o período",
      "title": "Taxa de evolução de incidentes de sincronização de pulseiras de sono",
      "evTooltip": "Incidentes",
      "indicatorHelp1": "Representa a porcentagem total de incidentes de sincronização de banda de sono que ocorreram durante os turnos do período selecionado.",
      "indicatorHelp2": "Este indicador é calculado com base no total de avaliações de FITNESS FOR DUTY esperadas no período de data selecionado.",
      "indicatorHelp3": "Atualmente, a taxa total de incidentes é",
      "evHelp1": "Representa a evolução da taxa de incidentes de sincronização da pulseira do sono durante o período de data selecionado.",
      "evHelp2": "O número representa a porcentagem de incidentes para a data dd-mm-yyyy.",
      "distHelp1": "Representa o número total de casos para cada status de sincronização da banda de sono durante o período de data selecionado.",
      "cat1Label": "Sincronizados",
      "cat1": "pessoas que cronometraram corretamente.",
      "cat2Label": "Sincronizado com atraso",
      "cat2": "pessoas que sincronizaram fora do tempo alocado e geraram um relatório FITNESS FOR DUTY atrasado.",
      "cat3Label": "Fora de sincronia",
      "cat3": "pessoas que registraram um incidente de sincronização e não geraram informações FITNESS FOR DUTY para uma data específica.",
      "desvHelp1": "Representa o número de variações geradas no período selecionado e seu status atual:",
      "desvCat1Label": "Fechado na hora",
      "desvCat2Label": "Aberto",
      "desvCat3Label": "Vencido",
      "desvCat4Label": "Fechado expirado",
      "labelRate": "Taxa de incidentes",
      "between": "Entre",
      "categoryHelp": "Categoria de agrupamento de resumo.",
      "driverNumber": "Pessoas",
      "driverNumberHelp": "Número de pessoas visualizadas no período de datas selecionado.",
      "atRisk": "Incidentes",
      "atRiskHelp": "Representa o número de incidentes de sincronização da banda de sono para a data dd-mm-yyyy.",
      "riskPeriod": "% incidentes do período",
      "driversAtRisk": "Evolução da taxa de incidentes",
      "riskDistribution": "Distribuição de estados de sincronização",
      "deviationDitribution": "Distribuição de desvios devido a incidentes",
      "noData": "Sem mais dados",
      "now": "Este período",
      "overdue": "Vencido",
      "closedoverdue": "Fechado expirado",
      "open": "Aberto",
      "closed": "Fechado",
      "generalHelp": "* Incidente: Refere-se à(s) ocasião(ões) em que uma ou várias pessoas não realizaram o processo de sincronização da pulseira do sono para o cálculo de FITNESS FOR DUTY."
    },
    "lastDataView": {
      "name": "Nome",
      "categories": "Categorias",
      "categoriesHelp": "Categoria à qual a pessoa pertence, por exemplo, fábrica, operação, transportador.",
      "workingShiftGroup": "Grupo de turnos",
      "workingShiftGroupHelp": "Corresponde ao grupo de rotação de turnos ao qual a pessoa está atribuída na data da consulta.",
      "ffdScore": "Pontuação FFD",
      "ffdScoreHelp": "Corresponde ao resultado FITNESS FOR DUTY. Esta pontuação é calculada com base no sono e vigília nas últimas 48 horas.",
      "calcDate": "Data de cálculo",
      "calcDateHelp": "Corresponde à data e hora em que a avaliação foi realizada FITNESS FOR DUTY.",
      "fitnessForDuty": "Pulseiras de sono Fitness For Duty",
      "ACCEPTED": "Aprovado",
      "FAIR": "Aprovado com comentários",
      "REJECTED": "Rejeitado",
      "NODATA": "Incidente fora de sincronia",
      "ACCEPTEDHelp": "entre 100 e 80 pontos",
      "FAIRHelp": "entre 81 e 60 pontos",
      "REJECTEDHelp": "entre 59 e 0 pontos",
      "NODATAHelp": "incidente de sincronização",
      "syncDate": "Informações de sincronização mais recentes",
      "last48hoursSleepInHour": "Últimas 48 horas de sono",
      "last24hoursSleepInHour": "Últimas 24 horas de sono",
      "hoursFromWakeUp": "Horas de vigília desde o último despertar"
    }
  },
  "ffdPvt": {
    "MONTH": "Mês",
    "DAY": "Dia",
    "WEEK": "Semana",
    "downloadExcel": "Descarregar dados em arquivo Excel",
    "downloadSummaryExcel": "Descarregar dados resumidos",
    "downloadNoProcessExcel": "Descarregar dados sem processar",
    "downloadFileNameSummary": "dados_cognus_pvt_resumo",
    "downloadFileNameNoProcess": "dados_cognus_pvt_nao_tratados",
    "downloadErrorDateRangeTitle": "Período de download não permitido",
    "downloadErrorDateRangeDescription": "Você excedeu o período de download permitido (3 dias ou menos). Para solicitar um relatório abrangendo um período superior a 31 dias, entre em contato com o help desk da Gauss Control.",
    "noDataAvailable": "Não há informação disponível",
    "apiError": "Erro ao carregar dados",
    "noDevs": "Sem desvios",
    "noData": "Não há dados",
    "lastPeriod": "Período anterior",
    "thisPeriod": "Período atual",
    "to": "a",
    "betterPeriod": "melhor em relação ao período anterior",
    "worstPeriod": "pior em relação ao período anterior",
    "equalPeriod": "Não há mudanças em relação ao período anterior",
    "graphTooltip": {
      "ACCEPTED": "Aprovados",
      "FAIR": "Aprovados com observações",
      "REJECTED": "Reprovados",
      "NODATA": "Incidente de não realização",
      "WITHOUTINFORMATION": "Incidente de não realização",
      "DONE": "A tempo",
      "DONEWITHDELAY": "Atrasado",
      "PENDING": "Não realizada"
    },
    "FFDResult": {
      "indicatorPeriod": "Taxa de reprovação Cognus do período",
      "resultsDistribution": "Distribuição de resultados Cognus do período",
      "title": "Evolução da taxa de reprovações de Cognus",
      "evTooltip": "Reprovados",
      "indicatorHelp1": "Representa a porcentagem total de ocasiões em que um número de pessoas foram avaliadas como NÃO APTAS para trabalhar, isto é conhecido como reprovação por Cognus.",
      "indicatorHelp2": "Este indicador se calcula com base no total de avaliações esperadas no período selecionado.",
      "indicatorHelp3": "Atualmente a taxa total de reprovações é",
      "evHelp1": "Representa a evolução da taxa de reprovações por Cognus durante o período selecionado.",
      "evHelp2": "O número representa a porcentagem de reprovações na data dd-mm-yyyy.",
      "distHelp1": "Representa a quantidade de pessoas para cada grupo de resultados de Cognus para período selecionado.",
      "cat1Label": "Aprovados",
      "cat1": "pessoas aptas para trabalhar.",
      "cat2Label": "Aprovados com observações",
      "cat2": "pessoas aptas para trabalhar sob monitoramento e/ou um plano de mitigação de medidas preventivas para fadiga.",
      "cat3Label": "Reprovados",
      "cat3": "pessoas que não se encontram em condições aptas para trabalhar.",
      "cat4Label": "Incidente de não realização",
      "cat4": "pessoas que não se apresentaram para realizar o teste PVT.",
      "desvHelp1": "Representa a quantidade de desvios gerados no período selecionado e seu estado atual:",
      "desvCat1Label": "Fechadas a tempo",
      "desvCat2Label": "Abertas",
      "desvCat3Label": "Vencidas",
      "desvCat4Label": "Fechado expirado",
      "labelRate": "Taxa reprovação",
      "between": "entre",
      "categoryHelp": "Categoria agrupamento de resumo.",
      "driverNumber": "Pessoas",
      "driverNumberHelp": "Quantidade de pessoas visualizadas no período selecionado.",
      "atRisk": "Reprovações de Cognus",
      "atRiskHelp": "Representa a quantidade de reprovações por Cognus para a data dd-mm-yyyy.",
      "riskPeriod": "% Reprovações do período",
      "driversAtRisk": "Evolução taxa reprovação Cognus",
      "riskDistribution": "Distribuição resultados Cognus",
      "deviationDitribution": "Distribuição desvios por reprovação de Cognus",
      "noData": "Não há mais dados",
      "now": "Este período",
      "overdue": "Vencido",
      "closedoverdue": "Fechado expirado",
      "open": "Aberto",
      "closed": "Fechado",
      "generalHelp": "* Reprovação: Se refere à(s) ocasião(ões) em que uma ou várias pessoas foram avaliadas como NÃO APTAS para trabalhar através do cálculo de COGNUS."
    },
    "FFDRealization": {
      "indicatorPeriod": "Taxa de incidentes de realização de teste PVT durante o período",
      "resultsDistribution": "Distribuição estado de realização de teste PVT durante o período",
      "title": "Evolução taxa de incidentes de realização de teste PVT",
      "evTooltip": "Incidentes",
      "indicatorHelp1": "Representa a porcentagem total de incidentes de realização de teste PVT que ocorreram durante turnos do período selecionado.",
      "indicatorHelp2": "Este indicador se calcula com base no total de avaliações por Cognus esperadas no período selecionado.",
      "indicatorHelp3": "Atualmente a taxa total de incidentes é",
      "evHelp1": "Representa a evolução da taxa de incidentes de realização de teste PVT durante o período selecionado.",
      "evHelp2": "O número representa a porcentagem de incidentes na data dd-mm-yyyy.",
      "distHelp1": "Representa a quantidade de casos totais para cada estado de realização de teste PVT durante o período selecionado.",
      "cat1Label": "A tempo",
      "cat1": "pessoas que realizaram o teste PVT no tempo adequado.",
      "cat2Label": "Atrasado",
      "cat2": "pessoas que realizaram o teste PVT fora do tempo estabelecido e que geraram um relatório de Cognus com atraso.",
      "cat3Label": "Não realizada",
      "cat3": "pessoas que não realizaram o teste PVT e não geraram informações de Cognus para uma data particular.",
      "desvHelp1": "Representa a quantidade de desvios gerados no período selecionado e seu estado atual:",
      "desvCat1Label": "Fechadas a tempo",
      "desvCat2Label": "Abertas",
      "desvCat3Label": "Vencidas",
      "desvCat4Label": "Fechadas vencidas",
      "labelRate": "Taxa incidentes",
      "between": "entre",
      "categoryHelp": "Categoria agrupamento de resumo.",
      "driverNumber": "Pessoas",
      "driverNumberHelp": "Quantidade de pessoas visualizadas no período selecionado.",
      "atRisk": "Incidentes",
      "atRiskHelp": "Representa a quantidade de incidentes de realização de teste PVT para a data dd-mm-yyyy.",
      "riskPeriod": "% Incidentes do período",
      "driversAtRisk": "Evolução taxa de incidentes",
      "riskDistribution": "Distribuição estados de realização teste PVT",
      "deviationDitribution": "Distribuição desvios por incidentes",
      "noData": "Não há mais dados",
      "now": "Este período",
      "overdue": "Vencido",
      "closedoverdue": "Fechado expirado",
      "open": "Aberto",
      "closed": "Fechado",
      "generalHelp": "* Incidente: Se refere à(s) ocasião(ões) em que uma ou várias pessoas não realizaram o processo de Teste PVT para o cálculo de COGNUS."
    },
    "lastDataView": {
      "name": "Nome",
      "categories": "Categorias",
      "categoriesHelp": "Categoria a que pertence a pessoa ex: planta, Operação, Contratada.",
      "workingShiftGroup": "Grupo de turnos",
      "workingShiftGroupHelp": "Corresponde ao grupo de rotação de turno a que está atribuída a pessoa na data de consulta.",
      "ffdScore": "Pontuação Cognus",
      "ffdScoreHelp": "Corresponde ao resultado de Cognus. Esta pontuação se calcula em função do teste PVT.",
      "calcDate": "Data de cálculo",
      "calcDateHelp": "Corresponde à data e hora em que se realizou a avaliação de Cognus.",
      "fitnessForDuty": "Cognus teste PVT",
      "ACCEPTED": "Aprovado",
      "FAIR": "Aprovado com observações",
      "REJECTED": "Rejeitado",
      "NODATA": "Incidente de não realização",
      "ACCEPTEDHelp": "entre 100 e 80 pontos.",
      "FAIRHelp": "entre 79 e 60 pontos.",
      "REJECTEDHelp": "entre 59 e 0 pontos.",
      "NODATAHelp": "incidente de realização teste PVT.",
      "LastSuccessfulAttempts": "Tentativas corretas",
      "LastMeasurements": "Quantidade de medições",
      "LastFailedAttempts": "Tentativas que falharam",
      "LastFalsePositives": "Falsos positivos",
      "FirstRealizationDate": "Data primeira tentativa",
      "FirstResult": "Resultados primeira tentativa",
      "LastRealizationDate": "Data última tentativa",
      "Version": "Número de testes PVT",
      "WITHOUTINFORMATION": "Incidente de não realização",
      "PENDING": "Não realizada",
      "DONE": "A tempo",
      "DONEWITHDELAY": "Atrasada",
      "rejectReasons": "Razão da rejeição",
      "rejectReason": "Razão da rejeição",
      "BREATHALYSER": "Alcoteste",
      "PVTTEST": "PVT",
      "FORM": "Pesquisa"
    }
  },
  "behaviour": {
    "MONTH": "Mês",
    "DAY": "Dia",
    "WEEK": "Semana",
    "downloadExcel": "Baixar dados em arquivo Excel",
    "downloadSummaryExcel": "Baixar dados de resumo",
    "downloadNoProcessExcel": "Baixar dados brutos",
    "noDataAvailable": "Nenhuma informação disponível",
    "apiError": "Erro ao carregar dados",
    "indicatorPeriod": "Nota comportamental do período",
    "resultsDistribution": "Distribuição da nota comportamental diária dentro do período",
    "title": "Evolução da nota comportamental diária",
    "evTooltip": "Nota comportamental",
    "indicatorHelp1": "Representa a pontuação comportamental média dos motoristas durante o período de data selecionado.",
    "indicatorHelp1Table": "Representa a média das pontuações comportamentais para a {category} durante o período de data selecionado.",
    "indicatorHelp2": "Este indicador foi calculado com base nas notas comportamentais com base nos quilômetros percorridos em cada viagem, e para cada motorista.",
    "indicatorHelp1Driver": "Representa a média de notas comportamentais do motorista durante o período de data selecionado.",
    "indicatorHelp2Driver": "Esse indicador foi calculado com base nas notas comportamentais com base nos quilômetros percorridos em cada viagem.",
    "indicatorHelp1Travel": "Corresponde à nota comportamental por viagem realizada.",
    "indicatorHelp2Travel": "Este indicador é calculado com base nos eventos associados a cada viagem (painel do lado direito).",
    "indicatorHelp1TravelModal": "Corresponde à nota comportamental da viagem.",
    "indicatorHelp2TravelModal": "É calculado com base nos indicadores exibidos no lado direito, esses indicadores são gerados de acordo com o número de eventos registrados por viagem, a duração da viagem e os quilômetros percorridos..",
    "indicatorHelp3": "Atualmente o grau comportamental é",
    "evHelp1": "Representa a evolução da nota comportamental média diária do período de data selecionado.",
    "evHelp2": "O número representa a nota comportamental da data dd-mm-yyyy.",
    "distHelp1": "Esta distribuição representa o número de motoristas categorizados por risco.",
    "distHelp2": "Esse indicador foi calculado com base nas notas comportamentais com base nos quilômetros percorridos em cada viagem.",
    "between": "Entre",
    "categoryHelp": "Categoria de agrupamento de resumo",
    "driverNumber": "Motoristas",
    "driverNumberHelp": "Número de motoristas exibidos nos períodos de data selecionados",
    "riskPeriod": "Nota comportamental média para o período",
    "driversAtRisk": "Evolução média do grau comportamental",
    "riskDistribution": "Distribuição de notas comportamentais para o período",
    "deviationDitribution": "Distribuição de desvios por rejeição de Cognus",
    "noData": "Sem mais dados",
    "now": "Este período",
    "overdue": "Vencido",
    "closedoverdue": "Fechado expirado",
    "open": "Aberto",
    "closed": "Fechado",
    "generalHelp": "A nota comportamental do período é calculada com base em todas as notas comportamentais diárias do intervalo de tempo em consulta.",
    "to": "a"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/summary/index.js